import React from "react";

const Card = (props) => {
  return (
    <div className="col">
      <div className="card shadow-sm">
        <img className="recentPublicationsImage" src={props.image} alt="" />
        <div className="card-body">
          <div className="h5">
            <a className="card-text" href={props.titleLink} target="_blank">
              {props.title}
            </a>
          </div>
          <b className="mt-2 textAlign">{props.author}</b>
          <div className="mt-1 textAlign">{props.paper}</div>
        </div>
      </div>
    </div>
  );
};

export default Card;
